<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <section class="content-header">
                <!-- <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Activate Robot</h1>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/dashboard">Home</router-link></li>
                            <li class="breadcrumb-item active">Change Password</li>
                            </ol>
                        </div>
                    </div>
                </div> -->
            </section>
            <section class="content activation">
                <div class="container-fluid">
                    <div class="" v-for="list in filterOrder" :key="list.id">
                        <h3 class="title">Activate Robot "{{ list.product_name }}"</h3>
                        <p>Please enter the Code to activate this robot!</p>
                    </div>

                    <form @submit.prevent="handleActivate()">
                        <div class="row">
                            <div class="col-lg-6 mb-3">
                                <div v-if="submitted && msgRes" class="alert alert-danger" role="alert">
                                    {{ msgRes.message }}
                                </div>
                                <div v-if="submitted && success" class="alert alert-success" role="alert">
                                    {{ success }}
                                </div>
                                <input type="text" v-model="activation_code" v-validate="'required'"
                                    placeholder="Enter a code.." class="form-control">
                                <div v-if="submitted && activation_code == ''" class="text-danger">
                                    Activation Code is Required
                                </div>
                                <div v-else-if="submitted && errors.has('activation_code')" class="text-danger">
                                    {{ errors.first('activation_code') }}
                                </div>
                                <div v-else-if="submitted && msgRes.activation_code" class="text-danger">
                                    {{ msgRes.activation_code[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4" :disabled="loading">
                                <div class="button pt-2 pb-4 d-flex align-items-center justify-content-center">
                                    <router-link to="/subscriptions" class="btn btn_grey m-2">Cancel</router-link>
                                    <button class="btn btn_red">
                                        <span v-show="loading" class="spinner-border spinner-border-sm mr-2"></span>
                                        <span v-show="!loading">Activate</span>
                                    </button>
                                    <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                                    <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
import jwt_decode from "jwt-decode"

// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
    name: "ChangePassword",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
        // VuePhoneNumberInput
    },
    data() {
        return {
            pendingorder: [],
            loading: false,
            submitted: false,
            activation_code: '',
            success: '',
            message: '',
            msgRes: '',
        }
    },
    computed: {
        filterOrder() {
            return this.pendingorder.filter((item) => item.id == this.$route.params.id)
        }
    },
    async mounted() {
        // if(!this.currentUser) {
        // 	this.$router.push('/login');
        // }

        var token = localStorage.getItem('access_token')
        var access_token = jwt_decode(token)
        const user_id = access_token.user_id
        if (!localStorage.getItem('user_id')) {
            localStorage.setItem('user_id', user_id)
        }

        await axios.get(`investor/${localStorage.user_id}/pendingorder/`)
            .then(response => {
                // console.log('ALL Pending Order: ', response.data.data)
                this.loading = false
                this.pendingorder = response.data.data
            }).catch(() => {
                this.loading = false
                // console.log('Error Pending Order: ', err.response)
            })
    },
    methods: {
        // sendUser(dataakun) {
        // 	this.datainvestor = dataakun;
        // 	console.log("Get Data Investor", this.datainvestor)
        // },
        handleActivate() {
            this.submitted = true
            // console.log("Activation Code : ", this.activation_code.toUpperCase());

            let data = new FormData()
            // data.append('id', this.transID)
            data.append('activation_code', this.activation_code.toUpperCase())
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    this.loading = true
                    axios.put(`investor/transaction/${this.$route.params.id}/activation_code`, data)
                        .then(result => {

                            // console.log('Activate: ', result)
                            this.success = result.data.message
                            setTimeout(() => {
                                // $('#activateRobot').modal('hide')
                                this.$router.push('/subscriptions')
                            }, 1000)
                        }).catch((error) => {
                            this.loading = false;
                            // $('#activateRobot').modal('show')
                            // console.log('Activation error: ',error)
                            this.message = error.data
                            this.msgRes = error.data
                            setTimeout(() => {
                                this.message = false
                                this.msgRes = false
                            }, 3000)
                        })
                } else {
                    this.loading = false
                }
            })
        },

    }
}
</script>

<style scoped>
.activation .title {
    font-weight: 700;
    color: var(--red);
}
</style>